import script from "./HomogenizationCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomogenizationCard.vue?vue&type=script&lang=ts&setup=true"

import "./HomogenizationCard.vue?vue&type=style&index=0&id=73aa6bc3&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73aa6bc3"]])

export default __exports__